import Immutable from 'immutable';
import {
  FLAG_GETTING_PREVENTIVE_REPORT,
  GET_PREVENTIVE_REPORT,
  CLEAR_PREVENTIVE_REPORT,
} from '../../../actions/types/mechanical-maintenance';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_PREVENTIVE_REPORT:
      return state.setIn(['all', 'loading'], payload);
    case GET_PREVENTIVE_REPORT:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_PREVENTIVE_REPORT:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};
